import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: '#1A1F2E',
          border: '1px solid rgba(63, 63, 70, 0.4)',
          color: '#fff',
        },
        className: 'sonner-toast',
      }}
      closeButton
      richColors
      expand={false}
      theme="dark"
    />
  );
}